<template>
    <div class="product">
        <div v-if="!fundcode" class="product-des">
            <div class="product-des-top">
                <span class="product-name fl" :title="basicInfo.portfolioName">{{basicInfo.portfolioName}}</span>
                <el-tooltip class="item" effect="light" content="更新数据，请勿重复点击" placement="bottom-start">
                    <el-button class="attention fr" @click="replace">重新计算指标</el-button>
                </el-tooltip>
            </div>
            <ul class="product-des-uls">
                <li>
                    <p>成立日期：<strong>{{basicInfo.createDate}}</strong></p>
                    <p>最大回撤：<strong>{{basicInfo.maxRetraceIndex}}</strong></p>
                    <p>今年以来收益：<strong :class="[{'rColor':(parseFloat(basicInfo.thisYearYield)>0)},{'gColor':(parseFloat(basicInfo.thisYearYield)<0)}]">{{basicInfo.thisYearYield}}</strong></p>
                </li>
                <li>
                    <p>净值日期：<strong>{{basicInfo.newestDate}}</strong></p>
                    <p>年化波动率：<strong>{{basicInfo.volatilityIndex}}</strong></p>

                </li>
                <li>
                    <p>单位净值：<strong>{{basicInfo.newestEquity}}</strong></p>
                    <p>夏普比率：<strong>{{basicInfo.sharpIndex}}</strong></p>
                </li>
                <li>
                    <p>累计收益：<strong :class="[{'rColor':(parseFloat(basicInfo.totalYield)>0)},{'gColor':(parseFloat(basicInfo.totalYield)<0)}]">{{basicInfo.totalYield}}</strong></p>
                    <p>年化收益：<strong :class="[{'rColor':(parseFloat(basicInfo.annualYield)>0)},{'gColor':(parseFloat(basicInfo.annualYield)<0)}]">{{basicInfo.annualYield}}</strong></p>
                </li>
            </ul>
        </div>
        <!-- 产品详情 -->
        <el-tabs v-model="activeColumn" type="border-card" class="tabs-card-two">
            <el-tab-pane name="one" label="组合表现">
                <div class="product-card">
                    <div class="product-card-left">
                        <el-tabs v-model="activeSy" type="border-card" class="tabs-card-three">
                            <el-tab-pane name="first" label="收益曲线">
                                <el-form :model="syForm" class="form-one" :inline="true" label-position="right">
                                    <el-form-item label="比较基准：">
                                        <el-select v-model="syForm.bjjz" class="select-one" style="width:100px;" value-key="code" @change="getSyChart">
                                            <el-option v-for="(item) in baseList" :key="item.code" :label="item.name" :value="item"></el-option>
                                        </el-select>
                                    </el-form-item>
                                    <br>
                                    <el-form-item style="margin-right:30px;">
                                        <el-radio-group v-model="syForm.time" class="radio-btnt" value-key="id" @change="timeChange('time')">
                                            <el-radio-button v-for="(item) in timeList.slice(0,3)" :key="item.id" :label="item.name" :value="item.name"></el-radio-button>
                                        </el-radio-group>
                                        <el-select v-show="timeList.slice(3).length>0" v-model="syForm.more" class="select-one more" style="width:100px;margin-left:10px;" placeholder="更多" @change="timeChange('more')">
                                            <el-option v-for="(item) in timeList.slice(3)" :key="item.id+'m'" :label="item.name" :value="item.name"></el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item>
                                        <img src="@/assets/images/time.png" alt="" style="margin-right:10px;">
                                        <el-date-picker type="date" class="date-picker-two" :editable="false" placeholder="选择日期" v-model="syForm.startDate" :clearable="false" @change="dateChange"></el-date-picker>-
                                        <el-date-picker type="date" class="date-picker-two" :editable="false" placeholder="选择日期" v-model="syForm.endDate" :clearable="false" @change="dateChange"></el-date-picker>
                                    </el-form-item>
                                </el-form>
                                <div v-if="activeSy=='first'" style="width:100%;height:300px;"><chart :option="optionSyqx" id="syqx"></chart></div>
                            </el-tab-pane>
                            <el-tab-pane name="second" label="历史净值">
                                <el-table :data="lsjzList" class="table-one">
                                    <el-table-column label="净值日期" prop="dealDate"></el-table-column>
                                    <el-table-column label="单位净值" prop="unitEquity"></el-table-column>
                                    <el-table-column label="涨跌幅" prop="unitYield">
                                        <template slot-scope="scope">
                                            <span :class="[{'rColor':parseFloat(scope.row.unitYield)>0},{'gColor':parseFloat(scope.row.unitYield)<0}]">{{scope.row.unitYield}}</span>
                                        </template>
                                    </el-table-column>
                                </el-table>
                                <el-pagination
                                        class="pagination-one mt20"
                                        hide-on-single-page
                                        background
                                        :page-size="lsjzPageSize"
                                        layout="prev, pager, next"
                                        @current-change="handleCurrentChange"
                                        :total="lsjzTotal">
                                </el-pagination>
                            </el-tab-pane>
                        </el-tabs>
                        <!-- <span class="row-one-more" @click="exportData">净值导出</span> -->
                    </div>
                    <div class="product-card-right">
                        <el-tabs  v-model="activeDT" type="border-card" class="tabs-card-three">
                            <el-tab-pane label="动态回撤" name="dt">
                                <span class="product-card-right-sp">截止日期：{{dtDate}}</span>
                                <div style="width:100%;height:379px;"><chart :option="optionDthc" id="dthc"></chart></div>
                            </el-tab-pane>
                            <!-- <el-tab-pane label="波动走势" name="bd">
                                <span class="product-card-right-sp">截止日期：{{dtDate}}</span>
                                <chart style="width:560px;height:379px;" :option="optionBdzs" id="bdzs"></chart>
                            </el-tab-pane> -->
                        </el-tabs>
                    </div>
                </div>
                <div class="mt30">
                    <el-row class="row-one">
                        <span class="subtitle">标的收益</span>
                    </el-row>
                    <div style="width:100%;height: 450px;"><chart :option="optionBdsy" id="bdsy"></chart></div>
                </div>
                <div class="mt30">
                    <el-row class="row-one">
                        <span class="subtitle">区间收益</span>
                    </el-row>
                    <el-row class="mt10">
                        <el-form :model="qjsyForm" :inline="true" class="form-one" label-width="90px" label-position="left" style="display:inline-block;">
                            <el-form-item label="展现形式：" style="margin-right:25px;">
                                <el-radio-group v-model="qjsyForm.show" class="radio-btnt padd">
                                    <el-radio-button label="图"></el-radio-button>
                                    <el-radio-button label="表"></el-radio-button>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item label="比较基准：">
                                <el-select v-model="qjsyForm.bjjz" class="select-one" style="width:100px;" value-key="code">
                                    <el-option v-for="(item) in baseList" :key="item.code" :label="item.name" :value="item"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-form>
                        <el-radio-group class="radio-btns fr mt5" v-model="qjsyRadio">
                            <el-radio-button label="阶段表现"></el-radio-button>
                            <el-radio-button label="年度表现"></el-radio-button>
                        </el-radio-group>
                    </el-row>
                    <div v-if="qjsyForm.show=='图'" style="width:100%;height: 450px;"><chart :option="optionQjsy" id="qjsy"></chart></div>
                    <el-table v-else :data="optionQjsy.series" class="table-one mt20 mb40" border>
                        <el-table-column prop="name"></el-table-column>
                        <el-table-column v-for="(item,i) in optionQjsy.xAxis.data" :key="i" :label="String(optionQjsy.xAxis.data[i])">
                            <template slot-scope="scope"><span :class="[{'rColor':parseFloat(scope.row.data[i])>0},{'gColor':parseFloat(scope.row.data[i])<0}]">{{parseFloat(scope.row.data[i]*100).toFixed(2)}}%</span></template>
                        </el-table-column>
                    </el-table>
                    <el-row class="row-one">
                        <span class="subtitle">区间风险</span>
                    </el-row>
                    <el-row class="mt10">
                        <el-form :model="qjfxForm" :inline="true" class="form-one" label-width="90px" label-position="left" style="display:inline-block;">
                            <el-form-item label="展现形式：" style="margin-right:25px;">
                                <el-radio-group v-model="qjfxForm.show" class="radio-btnt padd">
                                    <el-radio-button label="图"></el-radio-button>
                                    <el-radio-button label="表"></el-radio-button>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item label="比较基准：" style="margin-right:25px;">
                                <el-select v-model="qjfxForm.bjjz" class="select-one" style="width:100px;" value-key="code">
                                    <el-option v-for="(item) in baseList" :key="item.code" :label="item.name" :value="item"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="指标类型：">
                                <el-radio-group v-model="qjfxForm.indexType" class="radio-btnt padd">
                                    <el-radio-button label="最大回撤"></el-radio-button>
                                    <el-radio-button label="波动率"></el-radio-button>
                                    <el-radio-button label="下行标准差"></el-radio-button>
                                </el-radio-group>
                            </el-form-item>
                        </el-form>
                        <el-radio-group class="radio-btns fr mt5" v-model="qjfxRadio">
                            <el-radio-button label="阶段表现"></el-radio-button>
                            <el-radio-button label="年度表现"></el-radio-button>
                        </el-radio-group>
                    </el-row>
                    <div v-if="qjfxForm.show=='图'" style="width:100%;height:450px;"><chart :option="optionQjfx" id="qjfx"></chart></div>
                    <el-table v-else :data="optionQjfx.series" class="table-one mt20 mb40" border>
                        <el-table-column prop="name"></el-table-column>
                        <el-table-column v-for="(item,i) in optionQjfx.xAxis.data" :key="i" :label="String(optionQjfx.xAxis.data[i])">
                            <template slot-scope="scope"><span :class="[{'rColor':parseFloat(scope.row.data[i])>0},{'gColor':parseFloat(scope.row.data[i])<0}]">{{parseFloat(scope.row.data[i]*100).toFixed(2)}}%</span></template>
                        </el-table-column>
                    </el-table>
                    <el-row class="row-one">
                        <span class="subtitle">综合指标</span>
                    </el-row>
                    <el-row class="mt10">
                        <el-form :model="zhzbForm" :inline="true" class="form-one" label-width="90px" label-position="left" style="display:inline-block;">
                            <el-form-item label="展现形式：" style="margin-right:25px;">
                                <el-radio-group v-model="zhzbForm.show" class="radio-btnt padd">
                                    <el-radio-button label="图"></el-radio-button>
                                    <el-radio-button label="表"></el-radio-button>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item label="比较基准：" style="margin-right:25px;">
                                <el-select v-model="zhzbForm.bjjz" class="select-one" style="width:100px;" value-key="code">
                                    <el-option v-for="(item) in baseList" :key="item.code" :label="item.name" :value="item"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="指标类型：">
                                <el-radio-group v-model="zhzbForm.indexType" class="radio-btnt padd">
                                    <el-radio-button label="夏普比率"></el-radio-button>
                                    <el-radio-button label="索提诺比率"></el-radio-button>
                                    <el-radio-button label="卡玛比率"></el-radio-button>
                                </el-radio-group>
                            </el-form-item>
                        </el-form>
                        <el-radio-group class="radio-btns fr mt5" v-model="zhzbRadio">
                            <el-radio-button label="阶段表现"></el-radio-button>
                            <el-radio-button label="年度表现"></el-radio-button>
                        </el-radio-group>
                    </el-row>
                    <div v-if="zhzbForm.show=='图'" style="width:100%;height:450px;"><chart :option="optionZhzb" id="zhzb"></chart></div>
                    <el-table v-else :data="optionZhzb.series" class="table-one mt20 mb40" border>
                        <el-table-column prop="name"></el-table-column>
                        <el-table-column v-for="(item,i) in optionZhzb.xAxis.data" :key="i" :label="String(optionZhzb.xAxis.data[i])">
                            <template slot-scope="scope"><span>{{scope.row.data[i]?parseFloat(scope.row.data[i]).toFixed(2):'--'}}</span></template>
                        </el-table-column>
                    </el-table>
                    <ul class="index-info-ul">
                        <li>夏普比率（Sharpe Ratio）：（投资组合预期报酬率-无风险利率）/投资组合的标准差，即风险调整后收益，反映每单位风险的超额收益，该比率越大越好。</li>
                        <li>索提诺比率（Sortion Ratio）：（投资组合预期报酬率-无风险利率）/投资组合的下行标准差，该比率越高，表明基金承担相同单位下行风险能获得更高的超额回报率。</li>
                        <li>卡玛比率（Calmar Ratio）：年化收益率/历史最大回撤率，描述年化收益率和历史最大回撤率之间的关系。该比率越大，基金的业绩表现越好。</li>
                    </ul>
                </div>  
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
    import chart from "../../components/chart";
    export default {
        name: "product",
        props: ['fundcode','active'],
        components:{
            chart
        },
        data(){
            return{
                activeColumn:'one',
                PortfolioCode:'',
                basicInfo:{
                    portfolioName: '',
                    createDate: '',       //创建日期
                    newestEquity:'',      //最新净值
                    newestDate: '',       //最新净值日期
                    totalYield: '',       //累计收益
                    annualYield: '',      //年化收益
                    maxRetraceIndex: '',  //最大回撤
                    sharpIndex: '',       //夏普比率
                    volatilityIndex: '',  //波动率
                    thisYearYield: '',    //今年以来收益
                },
                activeSy:'first',
                syForm:{
                    bjjz:'',
                    time:'',
                    more:'',
                    startDate:'',
                    endDate:''
                },
                timeList:[],
                baseList:[],
                optionSyqx:{
                    graphic:[
                        {type:'text',left:'center',top:'90', z:-1,
                            style:{text: '展恒金方私募数据平台',fill:'#DDD',font:'normal 35px Microsoft YaHei'}
                        }
                    ],
                    title:{},
                    color:['#B81616','#E4DE0A','#B161CF','#01567F'],
                    legend:{
                        bottom:0,itemGap:20,textStyle:{fontSize:14,color:'#333'}
                    },
                    grid: {top:'5%',left: '2%',right: 35,bottom: '20%',containLabel: true},
                    xAxis:{
                        type:'category',
                        data:[],
                        axisLabel:{fontSize:12,color: "#333"},
                        axisLine:{lineStyle:{color: "#DDD"}},
                        boundaryGap: false,
                    },
                    yAxis:{
                        type:'value',
                        axisLabel: {
                            formatter:function (val){return (val*100).toFixed(2)+'%'},
                            fontSize:14,color:'#333'
                        }
                    },
                    tooltip: {
                        trigger: 'axis',
                        formatter:function (params) {

                            var htmlStr='<div class="echarts-tooltip-one"><table><tr><td>数据日期：</td><td>'+params[0].name+'</td></tr>';
                            for(let i=0;i<params.length;i++){
                                htmlStr+='<tr><td><span class="color-block" style="background:'+params[i].color+'"></span>'+params[i].seriesName+'：</td><td class="'+(params[i].value>0?'rColor':'gColor')+'">'+(params[i].value*100).toFixed(2)+'%</td></tr>';
                            }
                            htmlStr+='</table></div>';
                            return htmlStr;
                        }
                    },
                    series:[],
                    dataZoom:[
                        {
                            type:'inside',
                            start:0,
                            end:100
                        },
                        {
                            start:0,
                            end:100,
                            bottom:'13%',
                            height:6,
                            handleIcon: 'M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4v1.3h1.3v-1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z',
                            handleSize: '250%',
                            borderColor:'transparent',
                            backgroundColor:'#e9eef2',
                            fillerColor:'#CBD3DA',
                            handleStyle: {
                                color: '#fff',
                                shadowBlur: 3,
                                shadowColor: '#CBD3DA',
                                shadowOffsetX: 2,
                                shadowOffsetY: 2
                            },
                            showDetail:false,
                            brushSelect:false,
                        }
                    ]
                },
                activeDT:'dt',
                dtDate:'',
                optionDthc:{
                    graphic:[
                        {type:'text',left:'center',top:'center', z:-1,
                            style:{text: '展恒金方私募数据平台',fill:'#DDD',font:'normal 35px Microsoft YaHei'}
                        }
                    ],
                    title:{},
                    color:['#C13A3B'],
                    legend:{
                        bottom:0,itemGap:20,textStyle:{fontSize:14,color:'#333'}
                    },
                    grid: {top:'10%',left: '2%',right: 35,bottom: '15%',containLabel: true},
                    xAxis:{
                        type:'category',
                        data:[],
                        axisLabel:{fontSize:12,color: "#333"},
                        axisLine:{lineStyle:{color: "#DDD"}},
                        boundaryGap: false,
                    },
                    yAxis:{
                        type:'value',
                        axisLabel: {
                            formatter:function (val){return (val*100).toFixed(2)+'%'},
                            fontSize:14,color:'#333'
                        }
                    },
                    tooltip: {
                        trigger: 'axis',
                        formatter:function (params) {
                            var htmlStr='<div class="echarts-tooltip-one"><table><tr><td>数据日期：</td><td>'+params[0].name+'</td></tr>';
                            for(let i=0;i<params.length;i++){
                                htmlStr+='<tr><td><span class="color-block" style="background:'+params[i].color+'"></span>'+params[i].seriesName+'：</td><td class="'+(params[i].value>0?'rColor':'gColor')+'">'+(params[i].value*100).toFixed(2)+'%</td></tr>';
                            }
                            htmlStr+='</table></div>';
                            return htmlStr;
                        }
                    },
                    series:[],
                    dataZoom:[
                        {
                            type:'inside',
                            start:0,
                            end:100
                        },
                        {
                            start:0,
                            end:100,
                            bottom:'10%',
                            height:6,
                            handleIcon: 'M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4v1.3h1.3v-1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z',
                            handleSize: '250%',
                            borderColor:'transparent',
                            backgroundColor:'#e9eef2',
                            fillerColor:'#CBD3DA',
                            handleStyle: {
                                color: '#fff',
                                shadowBlur: 3,
                                shadowColor: '#CBD3DA',
                                shadowOffsetX: 2,
                                shadowOffsetY: 2
                            },
                            showDetail:false,
                            brushSelect:false,
                        }
                    ]
                },
                optionBdzs:{
                    graphic:[
                        {   type:'text',left:'center',top:'center', z:-1,style:{text: '展恒金方私募数据平台',fill:'#DDD',font:'normal 35px Microsoft YaHei'}    }
                    ],
                    title:{},
                    color:['#C13A3B'],
                    legend:{
                        bottom:0,itemGap:20,textStyle:{fontSize:14,color:'#333'}
                    },
                    grid: {top:'10%',left: '2%',right: 35,bottom: '15%',containLabel: true},
                    xAxis:{
                        type:'category',
                        data:[],
                        axisLabel:{fontSize:12,color: "#333"},
                        axisLine:{lineStyle:{color: "#DDD"}},
                        boundaryGap: false,
                    },
                    yAxis:{
                        type:'value',
                        axisLabel: {
                            formatter:function (val){return (val*100).toFixed(2)+'%'},
                            fontSize:14,color:'#333'
                        }
                    },
                    tooltip: {
                        trigger: 'axis',
                        formatter:function (params) {
                            var htmlStr='<div class="echarts-tooltip-one"><table><tr><td>数据日期：</td><td>'+params[0].name+'</td></tr>';
                            for(let i=0;i<params.length;i++){
                                htmlStr+='<tr><td><span class="color-block" style="background:'+params[i].color+'"></span>'+params[i].seriesName+'：</td><td class="'+(params[i].value>0?'rColor':'gColor')+'">'+(params[i].value*100).toFixed(2)+'%</td></tr>';
                            }
                            htmlStr+='</table></div>';
                            return htmlStr;
                        }
                    },
                    series:[],
                    dataZoom:[
                        {
                            type:'inside',
                            start:0,
                            end:100
                        },
                        {
                            start:0,
                            end:100,
                            bottom:'10%',
                            height:6,
                            handleIcon: 'M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4v1.3h1.3v-1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z',
                            handleSize: '250%',
                            borderColor:'transparent',
                            backgroundColor:'#e9eef2',
                            fillerColor:'#CBD3DA',
                            handleStyle: {
                                color: '#fff',
                                shadowBlur: 3,
                                shadowColor: '#CBD3DA',
                                shadowOffsetX: 2,
                                shadowOffsetY: 2
                            },
                            showDetail:false,
                            brushSelect:false,
                        }
                    ]
                },
                lsjzList:[],
                lsjzPage:1,
                lsjzPageSize:8,
                lsjzTotal:0,
                // 标的收益
                optionBdsy:{
                    graphic:[
                        {type:'text',left:'center',top:'170', z:-1,
                            style:{text: '展恒金方私募数据平台',fill:'#DDD',font:'normal 35px Microsoft YaHei'}
                        }
                    ],
                    title:{},
                    legend:{
                        type:'scroll',bottom:0,itemGap:20,textStyle:{fontSize:14,color:'#333',}
                    },
                    grid: {top:'5%',left: '2%',right: 35,bottom: '20%',containLabel: true},
                    xAxis:{
                        type:'category',
                        data:[],
                        axisLabel:{fontSize:12,color: "#333"},
                        axisLine:{lineStyle:{color: "#DDD"}},
                        boundaryGap: false,
                    },
                    yAxis:{
                        type:'value',
                        axisLabel: {
                            formatter:function (val){return (val*100).toFixed(2)+'%'},
                            fontSize:14,color:'#333'
                        }
                    },
                    tooltip: {
                        trigger: 'axis',
                        formatter:function (params) {

                            var htmlStr='<div class="echarts-tooltip-one"><table><tr><td>数据日期：</td><td>'+params[0].name+'</td></tr>';
                            for(let i=0;i<params.length;i++){
                                htmlStr+='<tr><td><span class="color-block" style="background:'+params[i].color+'"></span>'+params[i].seriesName+'：</td><td class="'+(params[i].value>0?'rColor':'gColor')+'">'+(params[i].value*100).toFixed(2)+'%</td></tr>';
                            }
                            htmlStr+='</table></div>';
                            return htmlStr;
                        }
                    },
                    series:[],
                    dataZoom:[
                        {
                            type:'inside',
                            start:0,
                            end:100
                        },
                        {
                            start:0,
                            end:100,
                            bottom:'13%',
                            height:6,
                            handleIcon: 'M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4v1.3h1.3v-1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z',
                            handleSize: '250%',
                            borderColor:'transparent',
                            backgroundColor:'#e9eef2',
                            fillerColor:'#CBD3DA',
                            handleStyle: {
                                color: '#fff',
                                shadowBlur: 3,
                                shadowColor: '#CBD3DA',
                                shadowOffsetX: 2,
                                shadowOffsetY: 2
                            },
                            showDetail:false,
                            brushSelect:false,
                        }
                    ]
                },
                qjsyForm:{bjjz:'',show:'图'},
                qjsyData:{},
                qjsyRadio:'阶段表现',
                optionQjsy:{
                    graphic:[
                        {type:'text',left:'center',top:'150', z:-1,
                            style:{text: '展恒金方私募数据平台',fill:'#DDD',font:'normal 44px Microsoft YaHei'}
                        }
                    ],
                    title:{},
                    color:['#D31D1D','#FF7723','#0263FF','#8E30FF'],
                    legend:{
                        bottom:30,itemGap:20,textStyle:{fontSize:14,color:'#333'}
                    },
                    grid: {top:'60',left: '3%',right: '3%',bottom: 65,containLabel: true},
                    xAxis:{
                        type:'category',
                        data:[],
                        axisLabel:{fontSize:12,color: "#333"},
                        axisLine:{lineStyle:{color: "#DDD"}},
                        boundaryGap: true,
                    },
                    yAxis:{
                        name:'收益率',nameGap:25,nameTextStyle:{padding:[0,50,0,0],fontSize:14,color:"#5D5D5D"},
                        type:'value',
                        axisLabel: {
                            formatter:function (val){return (val*100).toFixed(2)+'%'},
                            fontSize:14,color:'#333'
                        }
                    },
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: "shadow",
                            shadowStyle: {color: "rgba(0, 0, 0, 0.08)"}
                        },
                        formatter:function (params) {
                            var htmlStr='<div class="echarts-tooltip-one"><table><tr><td>数据日期：</td><td>'+params[0].name+'</td></tr>';
                            for(let i=0;i<params.length;i++){
                                htmlStr+='<tr><td><span class="color-block" style="background:'+params[i].color+'"></span>'+params[i].seriesName+'：</td><td class="'+(params[i].value>0?'rColor':'gColor')+'">'+(params[i].value*100).toFixed(2)+'%</td></tr>';
                            }
                            htmlStr+='</table></div>';
                            return htmlStr;
                        }
                    },
                    series:[],
                },
                qjfxForm:{bjjz:'',indexType:'最大回撤',show:'图'},
                qjfxData:{},
                qjfxRadio:'阶段表现',
                optionQjfx:{
                    graphic:[
                        {type:'text',left:'center',top:'center', z:-1,
                            style:{text: '展恒金方私募数据平台',fill:'#DDD',font:'normal 44px Microsoft YaHei'}
                        }
                    ],
                    title:{},
                    color:['#D31D1D','#FF7723','#0263FF','#8E30FF'],
                    legend:{
                        bottom:30,itemGap:20,textStyle:{fontSize:14,color:'#333'}
                    },
                    grid: {top:'60',left: '3%',right: '3%',bottom: 65,containLabel: true},
                    xAxis:{
                        type:'category',
                        data:[],
                        axisLabel:{fontSize:12,color: "#333"},
                        axisLine:{lineStyle:{color: "#DDD"}},
                        boundaryGap: true,
                    },
                    yAxis:{
                        name:'收益率',nameGap:25,nameTextStyle:{padding:[0,50,0,0],fontSize:14,color:"#5D5D5D"},
                        type:'value',
                        axisLabel: {
                            formatter:function (val){return (val*100).toFixed(2)+'%'},
                            fontSize:14,color:'#333'
                        }
                    },
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: "shadow",
                            shadowStyle: {color: "rgba(0, 0, 0, 0.08)"}
                        },
                        formatter:function (params) {
                            var htmlStr='<div class="echarts-tooltip-one"><table><tr><td>数据日期：</td><td>'+params[0].name+'</td></tr>';
                            for(let i=0;i<params.length;i++){
                                htmlStr+='<tr><td><span class="color-block" style="background:'+params[i].color+'"></span>'+params[i].seriesName+'：</td><td class="'+(params[i].value>0?'rColor':'gColor')+'">'+(params[i].value*100).toFixed(2)+'%</td></tr>';
                            }
                            htmlStr+='</table></div>';
                            return htmlStr;
                        }
                    },
                    series:[]
                },
                zhzbForm:{bjjz:'',indexType:'夏普比率',show:'图'},
                zhzbData:{},
                zhzbRadio:'阶段表现',
                optionZhzb:{
                    graphic:[
                        {type:'text',left:'center',top:'180', z:-1,
                            style:{text: '展恒金方私募数据平台',fill:'#DDD',font:'normal 44px Microsoft YaHei'}
                        }
                    ],
                    title:{},
                    color:['#D31D1D','#FF7723','#0263FF','#8E30FF'],
                    legend:{
                        bottom:30,itemGap:20,textStyle:{fontSize:14,color:'#333'}
                    },
                    grid: {top:'60',left: '3%',right: '3%',bottom: 65,containLabel: true},
                    xAxis:{
                        type:'category',
                        data:[],
                        axisLabel:{fontSize:12,color: "#333"},
                        axisLine:{lineStyle:{color: "#DDD"}},
                        boundaryGap: true,
                    },
                    yAxis:{
                        type:'value',
                        axisLabel: {
                            formatter:function (val){return val},
                            fontSize:14,color:'#333'
                        }
                    },
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: "shadow",
                            shadowStyle: {color: "rgba(0, 0, 0, 0.08)"}
                        },
                        formatter:function (params) {
                            var htmlStr='<div class="echarts-tooltip-one"><table><tr><td>数据日期：</td><td>'+params[0].name+'</td></tr>';
                            for(let i=0;i<params.length;i++){
                                htmlStr+='<tr><td><span class="color-block" style="background:'+params[i].color+'"></span>'+params[i].seriesName+'：</td><td>'+(params[i].value?params[i].value:'--')+'</td></tr>';
                            }
                            htmlStr+='</table></div>';
                            return htmlStr;
                        }
                    },
                    series:[]
                },
            }
        },
        watch: {
            qjsyForm: {
                handler (val) {
                    this.getPrivateFundPhaseIndex('qjsy');
                },
                deep: true
            },
            qjsyRadio:{
                handler (val) {
                    this.qjsyFun();
                },
                deep: false
            },
            qjfxForm:{
                handler (val) {
                    this.getPrivateFundPhaseIndex('qjfx');
                },
                deep: true
            },
            qjfxRadio:{
                handler (val) {
                    this.qjfxFun();
                },
                deep: false
            },
            zhzbForm:{
                handler (val) {
                    this.getPrivateFundPhaseIndex('zhzb');
                },
                deep: true
            },
            zhzbRadio:{
                handler (val) {
                    this.zhzbFun();
                },
                deep: false
            },
        },
        mounted(){
            this.PortfolioCode=this.$route.query.code;
            if(this.active && this.fundcode) {
                this.PortfolioCode = this.active == 'two'? this.fundcode.weightcode : this.fundcode.riskcode
            }
            this.getPortfolioArchives();
            this.getPortfolioDatePhase();
            this.getPortfolioValueByPage();
            this.getPortfolioRetraceCharts();
            this.getPortfolioValueCharts();
        },
        methods:{
            // 基金档案
            getPortfolioArchives(){
                const vm=this;
                vm.$http.post(vm.$apiPath.GetPortfolioArchives,{
                    PortfolioCode:vm.PortfolioCode
                }).then(res=>{
                    // console.log(res);
                    if(res.data.code==200){
                        let sdata=res.data.data;
                        vm.basicInfo=sdata;
                        document.title=sdata.portfolioName+'_金方数据库';
                    }
                })
            },
            // 获取组合参数
            getPortfolioDatePhase(){
                const vm=this;
                vm.$http.post(vm.$apiPath.GetPortfolioDatePhase,{
                    PortfolioCode:vm.PortfolioCode
                }).then(res=>{
                    // console.log(res);
                    if(res.data.code==200){
                        let sdata=res.data.data;
                        sdata.baseList.forEach((val,ind)=>{
                            vm.baseList.push({
                                name:val.name,
                                code:val.value
                            })
                        })
                        if(sdata.regionList && sdata.regionList.length>0){
                            sdata.regionList.forEach((val,ind)=>{
                                vm.timeList.push({
                                    id:ind,
                                    name:val.region,
                                    start:val.startDate,
                                    end:val.endDate
                                })
                                if(val.region == "成立以来") {
                                    vm.syForm.startDate = val.startDate
                                    vm.syForm.endDate = val.endDate
                                }
                            })
                            vm.syForm.time=vm.timeList[0].name;
                        }

                        // 初始化
                        vm.syForm.bjjz=vm.baseList[0];
                        vm.qjsyForm.bjjz=vm.baseList[0];
                        vm.qjfxForm.bjjz=vm.baseList[0];
                        vm.zhzbForm.bjjz=vm.baseList[0];
                        this.getSyChart();
                    }
                })
            },
            dateChange() {
                this.syForm.time='';
                this.syForm.more='';
                this.getSyChart();
            },
            timeChange(type) {
                if(type == 'time') {
                    this.syForm.more=''
                } else if(type == 'more') {
                    this.syForm.time=''
                }
                this.getSyChart();
            },
            // 收益
            getSyChart(){
                const vm=this;
                let startDate='',endDate='';
                if(this.syForm.time==''&&this.syForm.more=='') {
                    startDate=vm.syForm.startDate;
                    endDate=vm.syForm.endDate;
                } else {
                    vm.timeList.forEach(v=>{
                        if(v.name==(vm.syForm.time!=''?vm.syForm.time:vm.syForm.more)){
                            startDate=v.start;
                            endDate=v.end;
                        }
                    })
                }
                vm.$http.post(vm.$apiPath.GetPortfolioTrendCharts,{
                    PortfolioCode: vm.PortfolioCode, //产品编号
                    StartDate: startDate, //走势图起始日期
                    EndDate: endDate, //走势图截止日期
                    BaseCode: vm.syForm.bjjz.code //比较基准编号
                }).then(res=>{
                    if(res.data.code==200){
                        // console.log(res);
                        let sdata=res.data.data;
                        let seriesData=[];
                        sdata.nameList.forEach((val,ind)=>{
                            seriesData.push({
                                name:val,
                                type:'line',symbol:'circle',showSymbol: false,symbolSize:8,
                                data:sdata.dataList[ind]
                            })
                            if(ind == 0){
                                seriesData[ind].areaStyle ={
                                    color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                        {
                                            offset: 0,
                                            color: 'rgba(255,9,9,0.5)'
                                        },
                                        {
                                            offset: 1,
                                            color: '#FFF'
                                        }
                                    ])
                                }
                            }
                        })
                        vm.optionSyqx.xAxis.data=sdata.dateList;
                        vm.optionSyqx.series=seriesData;
                    }
                })
            },
            handleCurrentChange(val){
                this.lsjzPage=val;
                this.getPortfolioValueByPage();
            },
            // 历史净值
            getPortfolioValueByPage(){
                const vm=this;
                vm.$http.post(vm.$apiPath.GetPortfolioValueByPage,{
                    PortfolioCode: vm.PortfolioCode, //产品编号
                    Page: vm.lsjzPage, //页数
                    PageNum: vm.lsjzPageSize //每页条数
                }).then(res=>{
                    // console.log(res);
                    if(res.data.code==200){
                        let sdata=res.data.data;
                        vm.lsjzList=sdata.dataList;
                        vm.lsjzTotal=sdata.recordCount;
                    }
                })
            },
            // 动态回撤
            getPortfolioRetraceCharts(){
                const vm=this;
                vm.$http.post(vm.$apiPath.GetPortfolioRetraceCharts,{
                    PortfolioCode: vm.PortfolioCode, //产品编号
                }).then(res=>{
                    if(res.data.code==200){
                        let sdata=res.data.data;
                        vm.dtDate=sdata.dateList[sdata.dateList.length-1];
                        vm.optionDthc.xAxis.data=sdata.dateList;
                        vm.optionDthc.series=[{
                                name:sdata.nameList[0],
                                type:'line',symbol:'circle',showSymbol: false,symbolSize:8,
                                data:sdata.dataList[0],
                                areaStyle:{
                                    color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                        {
                                            offset: 0,
                                            color: '#FFF'
                                        },
                                        {
                                            offset: 1,
                                            color: 'rgba(255,9,9,0.8)'
                                        }
                                    ])
                                },
                            }]
                    }
                })
            },
            getSy() {
                let vm = this
                vm.$http.post(vm.$apiPath.GetPortfolioPhaseIndex,{
                    PortfolioCode: vm.PortfolioCode, //产品编号
                    BaseCode: vm.qjsyForm.bjjz.code, //比较基准编号
                    IndexType: "区间收益" //指标类型【区间收益】
                }).then(res=>{
                    if(res.data.code==200){
                        vm.qjsyData=res.data.data;
                        vm.$nextTick(function(){
                            vm.qjsyFun();
                        })
                    }
                })
            },            
            getPrivateFundPhaseIndex(type){
                const vm=this;
                if(type=='qjsy'){
                     this.getSy();
                }else if(type=='qjfx'){
                    vm.$http.post(vm.$apiPath.GetPortfolioPhaseIndex,{
                        PortfolioCode: vm.PortfolioCode, //产品编号
                        BaseCode: vm.qjfxForm.bjjz.code, //比较基准编号
                        IndexType: vm.qjfxForm.indexType //指标类型【最大回撤、波动率、下行标准差】
                    }).then(res=>{
                        if(res.data.code==200){
                            vm.qjfxData=res.data.data;
                            vm.$nextTick(function(){
                                vm.qjfxFun();
                            })

                        }
                    })
                }else if(type=='zhzb'){
                    vm.$http.post(vm.$apiPath.GetPortfolioPhaseIndex,{
                        PortfolioCode: vm.PortfolioCode, //产品编号
                        BaseCode: vm.zhzbForm.bjjz.code, //比较基准编号
                        IndexType: vm.zhzbForm.indexType //指标类型【夏普比率、索提诺比率、卡玛比率】
                    }).then(res=>{
                        if(res.data.code==200){
                            vm.zhzbData=res.data.data;
                            vm.$nextTick(function(){
                                vm.zhzbFun();
                            })

                        }
                    })
                }

            },
            // 标的收益
            getPortfolioValueCharts() {
                let vm = this
                vm.$http.post(vm.$apiPath.GetPortfolioValueCharts,{
                    PortfolioCode: vm.PortfolioCode, //产品编号
                }).then(res=>{
                    if(res.data.code==200){
                        // console.log(res);
                        let sdata=res.data.data;
                        let seriesData=[];
                        sdata.nameList.forEach((val,ind)=>{
                            seriesData.push({
                                name:val,
                                type:'line',symbol:'circle',showSymbol: false,symbolSize:8,
                                data:sdata.dataList[ind]
                            })
                            
                        })
                        vm.optionBdsy.xAxis.data=sdata.dateList;
                        vm.optionBdsy.series=seriesData;
                    }
                })
            },
            // 区间收益
            qjsyFun(){
                const vm=this;
                let num=0;
                for(let i=0;i<vm.qjsyData.dateList.length;i++){
                    if(vm.qjsyData.dateList[i].length!=5){
                        num++;
                    }else{
                        break;
                    }
                }
                // console.log(num);
                if(vm.qjsyRadio=='阶段表现'){
                    let seriesData=[];
                    vm.qjsyData.nameList.forEach((val,ind)=>{
                        seriesData.push({
                            name:val,
                            type:'bar',barWidth:20,
                            data:vm.qjsyData.dataList[ind].slice(0,num)
                        })
                    })
                    vm.optionQjsy.xAxis.data=vm.qjsyData.dateList.slice(0,num);
                    vm.optionQjsy.series=seriesData;
                }else{
                    let seriesData=[];
                    vm.qjsyData.nameList.forEach((val,ind)=>{
                        seriesData.push({
                            name:val,
                            type:'bar',barWidth:20,
                            data:vm.qjsyData.dataList[ind].slice(num)
                        })
                    })
                    vm.optionQjsy.xAxis.data=vm.qjsyData.dateList.slice(num);
                    vm.optionQjsy.series=seriesData;
                }
            },
            // 区间风险
            qjfxFun(){
                const vm=this;
                let num=0;
                for(let i=0;i<vm.qjfxData.dateList.length;i++){
                    if(vm.qjfxData.dateList[i].length!=5){
                        num++;
                    }else{
                        break;
                    }
                }
                if(vm.qjfxRadio=='阶段表现'){
                    let seriesData=[];
                    vm.qjfxData.nameList.forEach((val,ind)=>{
                        seriesData.push({
                            name:val,
                            type:'bar',barWidth:20,
                            data:vm.qjfxData.dataList[ind].slice(0,num)
                        })
                    })
                    vm.optionQjfx.xAxis.data=vm.qjfxData.dateList.slice(0,num);
                    vm.optionQjfx.series=seriesData;
                }else{
                    let seriesData=[];
                    vm.qjfxData.nameList.forEach((val,ind)=>{
                        seriesData.push({
                            name:val,
                            type:'bar',barWidth:20,
                            data:vm.qjfxData.dataList[ind].slice(num)
                        })
                    })
                    vm.optionQjfx.xAxis.data=vm.qjfxData.dateList.slice(num);
                    vm.optionQjfx.series=seriesData;
                }
            },
            // 综合指标
            zhzbFun(){
                const vm=this;
                let num=0;
                for(let i=0;i<vm.zhzbData.dateList.length;i++){
                    if(vm.zhzbData.dateList[i].length!=5){
                        num++;
                    }else{
                        break;
                    }
                }
                if(vm.zhzbRadio=='阶段表现'){
                    let seriesData=[];
                    vm.zhzbData.nameList.forEach((val,ind)=>{
                        seriesData.push({
                            name:val,
                            type:'bar',barWidth:20,
                            data:vm.zhzbData.dataList[ind].slice(0,num)
                        })
                    })
                    vm.optionZhzb.xAxis.data=vm.zhzbData.dateList.slice(0,num);
                    vm.optionZhzb.series=seriesData;
                }else{
                    let seriesData=[];
                    vm.zhzbData.nameList.forEach((val,ind)=>{
                        seriesData.push({
                            name:val,
                            type:'bar',barWidth:20,
                            data:vm.zhzbData.dataList[ind].slice(num)
                        })
                    })
                    vm.optionZhzb.xAxis.data=vm.zhzbData.dateList.slice(num);
                    vm.optionZhzb.series=seriesData;
                }
            },
            // 净值导出
            exportData() {
                const vm=this;
                vm.$http.post(vm.$apiPath.ExportPrivateFundNetValue,{
                    PortfolioCode:vm.PortfolioCode
                }).then(res=>{
                    // console.log(res);
                    // 转化为blob对象
                    let blob = this.buildBlobByByte(res.data.data.value);
                    let filename = res.data.data.name;
                    this.downloadFile(blob, filename);
                    this.$message({
                        message: "导出成功~",
                        type: "success",
                    });
                })
            },
            downloadFile: function(blob, fileName) {
                const link = document.createElement('a')
                link.href = window.URL.createObjectURL(blob)
                link.download = fileName
                // 此写法兼容可火狐浏览器
                document.body.appendChild(link)
                const evt = document.createEvent('MouseEvents')
                evt.initEvent('click', false, false)
                link.dispatchEvent(evt)
                document.body.removeChild(link)
            },
            buildBlobByByte: function(data) {
                const raw = window.atob(data)
                const rawLength = raw.length
                const uInt8Array = new Uint8Array(rawLength)
                for (let i = 0; i < rawLength; ++i) {
                uInt8Array[i] = raw.charCodeAt(i)
                }
                return new Blob([uInt8Array])
            },
            replace() {
                const vm=this;
                vm.$http.post(vm.$apiPath.CalculatioPortfolio,{
                    PortfolioCode:vm.PortfolioCode,
                }).then(res => {
                    // console.log(res);
                    if( res.data.code == 200 && res.data.data.note) {
                        vm.$message.success('更新成功')
                        this.$router.go(0)
                    } else {
                        vm.$message.error('更新失败，请稍后再试')
                    }
                }).catch(err=>{})
            },
        }
    }
</script>

<style scoped lang="less">
.product{
    &-des{
        width:1200px;height:272px;background:@whiteColor;border-radius:5px;box-shadow:@boxShadow;margin:15px auto 0;padding:0 46px;box-sizing:border-box;
        &-top{
            width:100%;height:80px;border-bottom:1px solid @borderColor;padding-top:25px;box-sizing:border-box;
            .product-name{font-size:24px;font-weight:bold;color:@mainColor;}
            .qualification-query{width:68px;height:25px;border:1px solid @cosColor;border-radius:3px;background-color:@whiteColor;font-size:12px;color:@cosColor;padding:0;margin-left:15px;margin-top:3px;}
            .product-tabs{
                margin-top:10px;margin-left:5px;
                li{float:left;font-size:14px;line-height:1;color:@color3;padding:0 15px;border-right:1px dashed @color3;}
                li:last-child{border-right:0;}
            }
            .attention{width:110px;height:30px;border-radius:3px;border:1px solid @mainColor;font-size:14px;color:@mainColor;padding:0;background: @whiteColor;}
        }
        &-uls{
            width:100%;margin-top:30px;display:flex;justify-content: space-between;
            li{
                font-size:16px;color:@color6;line-height:43px;
                strong{color:@color3;}
                a{color:@mainColor;font-weight:bold;}
                .li-company{display:inline-block;width:280px;margin-right:20px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}
            }
            li:last-child{margin-right:0;}
        }

    }
    &-card{
        width:1160px;height:482px;margin:15px auto 0;
        &-left{
            box-sizing: border-box;position: relative;width:50%;height:100%;float:left;padding-right:15px;border-right:2px solid @cardTitBg;
            .row-one-more{position: absolute;right: 24px;top: 7px;}
        }
        &-right{
            box-sizing: border-box;width:50%;height:100%;float:right;padding-left:20px;
            &-sp{font-size:14px;color:@color6;}
        }
    }
    .index-info-ul{
       margin-top:20px;padding:0 10px;
        li{font-size:14px;color:@color6;padding:6px 15px;position:relative;}
        li::before{content:'';display:block;width:7px;height:7px;border-radius:50%;background:@color6;position:absolute;left:0;top:12px;}
    }
    .row-one {line-height: 40px;}
    .padd/deep/.el-radio-button__inner {padding:5px 18px;}
}
</style>